// Pure navigation state shared without importing the component graph.
// eslint-disable-next-line no-shadow
export enum SchedulerPageType {
  CALENDAR = 'calendar',
  COURSE_DETAILS = 'course-details',
  SECTION_DETAILS = 'section-details',
}
export type SchedulerPageState =
  | { type: SchedulerPageType.CALENDAR }
  | { type: SchedulerPageType.COURSE_DETAILS }
  | { type: SchedulerPageType.SECTION_DETAILS; courseId: string };
